import { Injectable } from '@angular/core';
import { InvoiceAdjustmentUpsertDto } from 'src/app/invoices/dto/invoice-adjustment-upsert.dto';
import { InvoiceLineItemUpsertDto } from 'src/app/invoices/dto/invoice-line-item-upsert.dto';
import { InvoiceUpsertDto } from 'src/app/invoices/dto/invoice-upsert.dto';
import { InvoiceCalculationsDto } from './dto/invoice-calculations.dto';

@Injectable({
  providedIn: 'root',
})
export class InvoiceUtilityService {
  constructor() {}

  calculateInvoiceTotals(invoice: InvoiceUpsertDto): InvoiceCalculationsDto {
    let totalCost = 0;
    let amountPaid = 0;
    let balance = 0;

    if (invoice && invoice.LineItems?.length > 0) {
      totalCost = this.calculateInvoiceTotal(invoice);

      // check for payments and calculate payment total
      for (const item of invoice.LineItems) {
        if (item.Payments.length > 0 || item.PaymentAmountToApply > 0) {
          amountPaid = this.calculatePaymentTotal(invoice);
          break;
        }
      }

      balance = totalCost - amountPaid;
    }
    return {
      totalCost,
      amountPaid,
      balance,
    };
  }

  calculateLineItemAdjustedAmountDue(lineItem: InvoiceLineItemUpsertDto): number {
    if (!lineItem) {
      return 0;
    }

    let adjAmtDue = lineItem.Quantity * (lineItem.UnitPrice ?? 0) + lineItem.BasePrice + lineItem.FlatFee;

    if (lineItem.Adjustments && lineItem.Adjustments.length > 0) {
      adjAmtDue += lineItem.Adjustments.map((x) => x.AdjustmentAmount).reduce((a, b) => a + b);
    }

    if (lineItem.Payments?.length) {
      for (const payment of lineItem.Payments) {
        adjAmtDue -= payment.Amount;
        if (payment.Adjustments?.length) {
          adjAmtDue -= payment.Adjustments?.map((x) => x.AdjustmentAmount).reduce((a, b) => a + b);
        }
      }
    }

    return Math.round(adjAmtDue * 100) / 100;
  }

  private calculateInvoiceTotal(invoice: InvoiceUpsertDto): number {
    const liTotal = invoice.LineItems.map((x) => x.Amount).reduce((a, b) => a + b);
    const flatLIAdj = new Array<InvoiceAdjustmentUpsertDto>();
    for (const lineItem of invoice.LineItems) {
      for (const adj of lineItem.Adjustments) {
        flatLIAdj.push(adj);
      }
    }

    let liAdjTotal = invoice.LineItems.map((x) => x.AdjustmentAmountToApply).reduce((a, b) => a + b);
    if (flatLIAdj.length > 0) {
      liAdjTotal += flatLIAdj.map((x) => x.AdjustmentAmount).reduce((a, b) => a + b);
    }
    return liTotal + liAdjTotal;
  }

  private calculatePaymentTotal(invoice: InvoiceUpsertDto) {
    let paymentTotal = 0;

    if (invoice.LineItems) {
      for (const item of invoice.LineItems) {
        if (item.Payments && item.Payments.length > 0) {
          for (const payment of item.Payments) {
            let existAdjTotal = 0;
            if (payment.Adjustments && payment.Adjustments.length > 0) {
              existAdjTotal += payment.Adjustments.map((x) => x.AdjustmentAmount).reduce((a, b) => a + b);
            }
            existAdjTotal += payment.AdjustmentAmountToApply;

            paymentTotal += payment.Amount + existAdjTotal;
          }
        }
        paymentTotal += item.PaymentAmountToApply;
      }
    }

    return paymentTotal;
  }
}
